import { createAction } from '@reduxjs/toolkit';

const saveServiceFormValues = createAction(
  'ui/sealink/journey/saveServiceFormValues'
);

const saveOriginalServiceFormValues = createAction(
  'ui/sealink/journey/saveOriginalServiceFormValues'
);
export { saveServiceFormValues, saveOriginalServiceFormValues };
